/* SnapBake Convert — global.js */
(function () {
  'use strict';

  /* ---------- Countdown (announcement bar) ---------- */
  document.querySelectorAll('[data-countdown-end]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown-end')).getTime();
    if (isNaN(end)) return;
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.textContent = '00:00:00'; return; }
      var h = Math.floor(d / 3600000);
      var m = Math.floor((d % 3600000) / 60000);
      var s = Math.floor((d % 60000) / 1000);
      var days = Math.floor(h / 24);
      h = h % 24;
      el.textContent =
        (days > 0 ? days + 'd ' : '') +
        String(h).padStart(2, '0') + ':' +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0');
      setTimeout(tick, 1000);
    }
    tick();
  });

  /* ---------- Bundle selector ---------- */
  document.querySelectorAll('[data-buybox]').forEach(function (box) {
    var radios = box.querySelectorAll('input[name="id"]');
    var priceEls = document.querySelectorAll('[data-selected-price]');

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2);
      var tpl = box.getAttribute('data-money-format') || '${{amount}}';
      return tpl.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function sync() {
      radios.forEach(function (r) {
        r.closest('.bundle').classList.toggle('is-selected', r.checked);
        if (r.checked) {
          var cents = parseInt(r.getAttribute('data-price'), 10);
          priceEls.forEach(function (p) { p.textContent = fmt(cents); });
        }
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  });

  /* ---------- Sticky ATC bar ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-buybox]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var passed = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.boundingClientRect.top < 0 && !e.isIntersecting) passed = true;
        if (e.isIntersecting) passed = false;
        sticky.classList.toggle('is-visible', passed);
      });
    }, { threshold: 0 }).observe(anchor);

    sticky.querySelector('[data-sticky-cta]').addEventListener('click', function (ev) {
      ev.preventDefault();
      var form = anchor.querySelector('form');
      if (form) form.submit();
    });
  }
})();
